import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { ip_back } from "../config";
import { hasDemoGroupPermission } from "../utils/demoGroupAccess";

const PermissionsContext = createContext();

export const PermissionsProvider = ({ children }) => {
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    const cached = localStorage.getItem("userPermissions");
    if (cached) {
      try {
        const parsed = JSON.parse(cached);
        setPermissions(parsed);
      } catch (e) {
        console.error("Failed to parse cached permissions:", e);
      }
    }

    const token = localStorage.getItem("token");
    if (!token) return;

    let userObj = null;
    try {
      userObj = JSON.parse(localStorage.getItem("user") || "{}");
    } catch {
      return;
    }
    if (userObj?.isSuperAdmin) return;

    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(`${ip_back}api/user/getProfile`, {
          headers: { Authorization: token },
        });
        if (cancelled || res.data?.status !== "success" || !res.data?.data) return;
        const data = res.data.data;
        const nextPerms = Array.isArray(data.permissions) ? data.permissions : [];

        setPermissions(nextPerms);
        localStorage.setItem("userPermissions", JSON.stringify(nextPerms));

        const stored = localStorage.getItem("user");
        if (stored) {
          try {
            const u = JSON.parse(stored);
            u.permissions = nextPerms;
            if (data.all_roles) u.all_roles = data.all_roles;
            if (data.all_role_names) u.all_role_names = data.all_role_names;
            if (data.primary_role_name !== undefined)
              u.primary_role_name = data.primary_role_name;
            if (data.hasCoachRole !== undefined)
              u.hasCoachRole = data.hasCoachRole;
            if (data.hasAdminRole !== undefined)
              u.hasAdminRole = data.hasAdminRole;
            if (data.hasPlayerRole !== undefined)
              u.hasPlayerRole = data.hasPlayerRole;
            if (data.isDualRole !== undefined) u.isDualRole = data.isDualRole;
            localStorage.setItem("user", JSON.stringify(u));
            window.dispatchEvent(new CustomEvent("smarttt-user-updated"));
          } catch {
            /* ignore */
          }
        }
      } catch {
        /* keep cached permissions from login */
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  const loadPermissions = (perms) => {
    console.log(perms);
    setPermissions(perms);
    localStorage.setItem("userPermissions", JSON.stringify(perms)); // optional cache
  };

  const hasPermission = (key) => {
    if (permissions?.some((perm) => perm.enum_value === key)) return true;
    return hasDemoGroupPermission(key);
  };

  return (
    <PermissionsContext.Provider
      value={{ permissions, loadPermissions, hasPermission }}
    >
      {children}
    </PermissionsContext.Provider>
  );
};

export const usePermissions = () => useContext(PermissionsContext);
